import { Stack, Typography, alpha } from '@mui/material';
import Iconify from 'src/components/iconify';
import { translateKey } from 'src/locales/translate';

/**
 * Caption shown next to the patient-notes editor while the visit still carries
 * an unsent draft: the clinic already has the text, the owner has not seen it
 * yet. Styled as a warning so the "not sent" part is impossible to miss.
 */
export default function VisitNotesDraftHint() {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{
        mb: 1,
        px: 1.5,
        py: 1,
        borderRadius: 1,
        color: 'warning.darker',
        bgcolor: (theme) => alpha(theme.palette.warning.main, 0.12),
      }}
    >
      <Iconify icon="eva:alert-triangle-outline" width={16} />
      <Typography variant="caption" sx={{ fontWeight: 600 }}>
        {translateKey('visit.notesDraftHint')}
      </Typography>
    </Stack>
  );
}
